/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 하단 버튼 스타일
 * 버전 : 1.0
 * 파일명 : CommonButtons.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-12-18
 * ================================================================ 
 * 수정일 : 2025-12-29, 강동형, 민트색 버튼 스타일 추가
 * ================================================================ */

import styled from "styled-components";

// 하단 버튼 래퍼
export const BottomButtonWrapper = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    gap: 10px;

    width: 100%;
    height: 82px;
    padding: 16px 20px;
    box-shadow: 0 -3px 8px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
`

// 민트색 버튼 스타일
export const MintButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    padding: 8px;
    border-radius: 5px;
    border: 1px solid #508A9C;
    background-color: #EEF6F8;
    color: #508A9C;
    font-weight: 500;
    font-size: 14px;
`